import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UpdateOfferExpirationPayload {
  offer_expiration_value: number
}

export function updateOfferExpirationAction(payload: UpdateOfferExpirationPayload): Promise<ApiResponse<unknown>> {
  return api.put<ApiResponse<unknown>>(`/offers/update-offer-expiration`, { ...payload })
}
